import { RuntimeErrorMessage } from '@blaze-runtime/engine-domain';
import { type WorkflowNode } from '@blaze-shared/workflow-domain';

/**
 * Guards the step from one node to the next: a node that hands control back to itself would run
 * the workflow forever, so execution aborts instead of taking the step.
 *
 * @throws `RuntimeErrorMessage.NodeTargetsItself` when `nextNode` is `node`.
 */
export function assertNextNodeIsNotSelf(node: WorkflowNode, nextNode: WorkflowNode | null): void {
  if (node.id === nextNode?.id) {
    throw new Error(`${RuntimeErrorMessage.NodeTargetsItself}`);
  }
}
